import React from 'react';
import withPortal from 'jd-library/withPortal'
import Modal from 'jd-library/Modal'
import './action-modal.scss'

const ActionModal = (props) => { 
    
    return (
        <div>
            <Modal
                settings={{
                    modalId: 'center-btn',
                    class: 'common-action-modal',
                    variant: 'action',
                }}
                onHidden={() => {
                    props.onHidden()
                }}
            >
                <Modal.CloseIcon />
                <Modal.Header>
                    {props.title}
                </Modal.Header>
                <Modal.Body className="modal-body">
                    <div>{props.content}</div>
                </Modal.Body>
                <Modal.CenterButton 
                    className="fs-sb"
                    variant={props.variant}
                    onClick={()=>{props.onclick()}}
                >
                    {props.btnName}
                </Modal.CenterButton>
            </Modal>
        </div>
    )
}
export default withPortal(ActionModal);    